// addon-guard.js
document.addEventListener('DOMContentLoaded', () => {
  // Store IDs as strings to avoid type mismatches
  const ADDON_PRODUCT_IDS = [
    '8431095939321',
    '8431096430841',
    '8431096660217',
    '8451270410489'
  ];

  // Hide dynamic checkout buttons on add-on product pages ONLY
  function hideDynamicButtonsOnAddonProductPage() {
    try {
      const productIdRaw = window?.meta?.product?.id;
      const productId = productIdRaw != null ? String(productIdRaw) : null;

      if (!productId || !ADDON_PRODUCT_IDS.includes(productId)) return;

      const hideButtons = () => {
        const wrappers = document.querySelectorAll(
          '.shopify-payment-button, #additional-checkout-buttons'
        );
        wrappers.forEach(el => {
          if (el.style.display !== 'none') {
            el.style.display = 'none';
          }
        });
      };

      // Hide immediately
      hideButtons();

      // Keep hiding them if Shopify re-injects them
      const observer = new MutationObserver(() => {
        hideButtons();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      console.error('addon-guard product page error', e);
    }
  }

  async function checkCartAndBlockIfNeeded() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();

      if (!cart || !cart.items || cart.items.length === 0) {
        // No items – nothing to block
        restoreCheckoutLinks();
        restoreCheckoutButtons();
        return;
      }

      // TRUE if every line item is an add-on
      const allItemsAreAddons = cart.items.every(item =>
        ADDON_PRODUCT_IDS.includes(String(item.product_id))
      );

      const shouldBlock = allItemsAreAddons;

      let message = '';
      if (allItemsAreAddons) {
        message =
          'Add-ons cannot be purchased alone. Please add a custom card to your cart to check out.';
      }

      // Buttons that trigger checkout
      const checkoutButtons = document.querySelectorAll(
        'button[name="checkout"], button[data-cart-checkout], .shopify-payment-button button'
      );

      checkoutButtons.forEach(btn => {
        if (shouldBlock) {
          btn.disabled = true;
          if (!btn.dataset.originalText) {
            btn.dataset.originalText = btn.innerText;
          }
          btn.innerText = 'Cannot checkout';
        } else {
          if (btn.dataset.originalText) {
            btn.innerText = btn.dataset.originalText;
          }
          btn.disabled = false;
        }
      });

      // Links that go straight to checkout (mini popup, etc.)
      const checkoutLinks = document.querySelectorAll(
        'a[href*="/checkout"], a[href*="checkouts"]'
      );

      checkoutLinks.forEach(link => {
        if (shouldBlock) {
          if (!link.dataset.originalHref) {
            link.dataset.originalHref = link.getAttribute('href');
          }
          link.setAttribute('href', 'javascript:void(0)');
        } else {
          if (link.dataset.originalHref) {
            link.setAttribute('href', link.dataset.originalHref);
          }
        }
      });

      // Show / clear message on cart page
      const cartForms = document.querySelectorAll('form[action="/cart"]');
      cartForms.forEach(form => {
        let msgEl = form.querySelector('.addon-guard-message');
        if (!msgEl) {
          msgEl = document.createElement('p');
          msgEl.className = 'addon-guard-message';
          msgEl.style.color = 'red';
          msgEl.style.marginTop = '10px';
          msgEl.style.fontWeight = '600';
          form.appendChild(msgEl);
        }
        msgEl.textContent = shouldBlock ? message : '';
      });
    } catch (e) {
      console.error('addon-guard error', e);
    }
  }

  // Helpers to fully restore state when cart is OK
  function restoreCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], button[data-cart-checkout], .shopify-payment-button button'
    );
    checkoutButtons.forEach(btn => {
      btn.disabled = false;
      if (btn.dataset.originalText) {
        btn.innerText = btn.dataset.originalText;
      }
    });
  }

  function restoreCheckoutLinks() {
    const checkoutLinks = document.querySelectorAll(
      'a[href="javascript:void(0)"][data-original-href], a[data-original-href]'
    );
    checkoutLinks.forEach(link => {
      if (link.dataset.originalHref) {
        link.setAttribute('href', link.dataset.originalHref);
      }
    });
  }

  // Run on load
  hideDynamicButtonsOnAddonProductPage();
  checkCartAndBlockIfNeeded();

  // Re-run after cart changes
  document.addEventListener('change', () => {
    setTimeout(checkCartAndBlockIfNeeded, 300);
  });

  document.addEventListener('click', event => {
    // When items are removed or cart is updated
    if (
      event.target.matches('[data-remove-item], [name="update"], [name="remove"]')
    ) {
      setTimeout(checkCartAndBlockIfNeeded, 300);
      return;
    }

    // When a product is added to cart (Add to cart buttons)
    if (
      event.target.matches(
        'button[name="add"], .product-form__submit, form[action^="/cart/add"] button[type="submit"]'
      )
    ) {
      // Give Shopify a moment to update cart + open the mini-cart,
      // then re-check and disable any quick checkout options if needed.
      setTimeout(checkCartAndBlockIfNeeded, 600);
    }
  });
});
